import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';

import SideBar from '../../components/SideBar';
import TopBar from '../../components/TopBar';
import useInitialization from '../../services/hooks/useInitialization';

import { IS_PRODUCTION } from '../../services/constants';
import { SIDEBAR_WIDTH_COLLAPSED, SIDEBAR_WIDTH_WITH0UT_SCROLL, SIDEBAR_WIDTH_WITH_SCROLL } from '../../constants/consts';
import './MainLayout.scss';

const MainLayout = ({ children }) => {
  const [drawerOpen, setDrawer] = useState(true);
  const [isScrollVisible, setIsScrollVisible] = useState(false);

  useInitialization();

  return (
    <Grid
      className="mainLayout"
      container
      style={{
        height: IS_PRODUCTION ? '100%' : 'calc(100% - 25px)',
      }}
    >
      <SideBar
        toggleDrawer={() => setDrawer((d) => !d)} open={drawerOpen}
        toggleScrollVisible={setIsScrollVisible}
      />

      <Grid
        container
        item
        style={{ paddingLeft: drawerOpen ? (isScrollVisible ? SIDEBAR_WIDTH_WITH_SCROLL : SIDEBAR_WIDTH_WITH0UT_SCROLL) : SIDEBAR_WIDTH_COLLAPSED }}
      >
        <TopBar toggleDrawer={() => setDrawer((d) => !d)} drawerOpen={drawerOpen} />
        <Grid className="tableWrapper">
          <Grid
            className="table"
            item
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {children}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

MainLayout.propTypes = {
  children: PropTypes.any,
};

export default MainLayout;
